import React, { useEffect, useState } from "react";
import { Users } from "lucide-react";
import CheckList from "components/checkList/CheckList";
import FeatureBadge from "components/featureBadge/FeatureBadge";
import ModalCloseButton from "components/modal/components/closeButton";
import UseContext from "hooks/useContext";

// Per user: two managers sharing a browser each get to read the card once.
const dismissedKey = (userId) => `privatePool.introDismissed.${userId || "anonymous"}`;

const readDismissed = (userId) => {
    try {
        return localStorage.getItem(dismissedKey(userId)) === "1";
    } catch {
        return false;
    }
};

/** Introduction of the private pool, above its list (same card as the job templates' one). */
const PrivatePoolIntro = () => {
    const { language, userDatas } = UseContext();
    const userId = userDatas?._id;
    const [isDismissed, setIsDismissed] = useState(() => readDismissed(userId));
    const label = (key, defaultValue) => language.getValue(`privatePool.intro.${key}`, defaultValue);

    // The user's profile may arrive after the first render.
    useEffect(() => {
        setIsDismissed(readDismissed(userId));
    }, [userId]);

    if (isDismissed) return null;

    const dismiss = () => {
        setIsDismissed(true);
        try {
            localStorage.setItem(dismissedKey(userId), "1");
        } catch {
            // Storage unavailable: hidden until the next visit only.
        }
    };

    return (
        <aside className="flex flex-col gap-4 rounded-2xl border border-gray-100 bg-white p-5">
            <div className="flex items-start justify-between gap-3">
                <div className="corner-smooth-12 flex h-11 w-11 shrink-0 items-center justify-center bg-yellow-50">
                    <Users size={22} color="#FF9600" aria-hidden="true" />
                </div>
                <ModalCloseButton onClick={dismiss} label={label("close", "Fermer")} size="sm" />
            </div>
            <div className="flex flex-col gap-1">
                <div className="mb-1">
                    <FeatureBadge>{label("badge", "Nouveau")}</FeatureBadge>
                </div>
                <h2 className="text-lg font-semibold leading-6 tracking-[-0.3px] text-gray-900">
                    {label("title", "Recrutez vos propres candidats")}
                </h2>
                <p className="text-sm leading-5 text-gray-600">
                    {label(
                        "description",
                        "Ajoutez les personnes que vous connaissez déjà. Jobbiz les embauche en intérim pour vous."
                    )}
                </p>
            </div>
            <CheckList
                items={[
                    { text: label("benefitContracts", "Contrats et paie gérés par Jobbiz") },
                    { text: label("benefitRate", "Un tarif réduit sur ces profils") },
                ]}
            />
        </aside>
    );
};

export default PrivatePoolIntro;
